export default "__VITE_ASSET__reyz7D0s__"